@if (isVisible) {
  <div class="chatbot-container">
    <!-- Chat Panel -->
    <div
      class="chat-panel-wrapper"
      #panelWrapper
      [@panelAnimation]="isOpen ? 'open' : 'closed'"
      (@panelAnimation.done)="onAnimationDone($event)"
    >
      <button
        type="button"
        class="resize-handle"
        (mousedown)="onResizeStart($event)"
        (touchstart)="onResizeStart($event)"
        aria-label="Resize chat window"
      ></button>
      @if (showPanel) {
        <app-chat-panel (closeRequested)="toggleChat()"></app-chat-panel>
      }
    </div>

    <!-- FAB Button -->
    <button
      mat-fab
      class="chat-fab"
      [class.is-close]="isOpen"
      (click)="toggleChat()"
      [attr.aria-label]="isOpen ? closeLabel : openLabel"
    >
      <mat-icon>{{ isOpen ? 'close' : 'smart_toy' }}</mat-icon>
    </button>
  </div>
}
